export default {
  onboardingSlides: {
    stepChip: "Étape {current} sur {total}",
  },
  onboardingWelcomeSlide: {
    title: "Bienvenue sur Tokatab !",
    intro: "Dans quelques minutes, vous jouerez vos premières notes.<br />Prêt(e) à commencer ?",
    start: "C'est parti !",
  },
  onboardingTutorialSlide: {
    title: "Votre piano est prêt, à vous de jouer !",
    intro: "Un tuto de quelques notes très simples pour prendre l’application en main — 2 minutes, promis.",
    doLater: "Je le ferai plus tard",
    playTutorial: "Je joue le tuto",
  },
  onboardingTrialSlideAb: {
    selectTitle: "Abonnez-vous pour débloquer <br /> l’intégralité des contenus <strong>Tokatab</strong> et progresser rapidement au piano",
    benefit1: "100+ morceaux du répertoire à apprendre",
    benefit2: "500+ exercices et vidéos pour apprendre les compétences clés au piano",
    benefit3: "Recommandations personnalisées de votre professeur virtuel",
    try14: "Essayer gratuitement pendant {days} jours",
    noSubscribe: "Ne pas s'abonner",
    trialExplanationTitle: "Comment fonctionne votre période d’essai",
    trialStep1Title: "Aujourd’hui",
    trialStep1Desc: "Débloquez votre accès complet à Tokatab",
    trialStep2Title: "Dans {reminderDay} jours",
    trialStep2Desc: "Vous recevrez un rappel de fin de période d’essai",
    trialStep3Title: "Dans {endDay} jours",
    trialStep3Desc: "Vous serez débité de {price} – vous pouvez annuler quand vous voulez sans frais avant cette date",
    trialStep4Title: "Dans les mois et années à venir",
    trialStep4Desc: "Profitez du professeur virtuel Tokatab et progressez au piano comme jamais auparavant !",
    startTrial: "Commencer l'essai gratuit",
    cancelTitle: "Vous ne souhaitez pas profiter de Tokatab Premium ?",
    premiumFaster: "Nos utilisateurs <strong>Premium progressent en moyenne 4 fois plus vite</strong> que les autres",
    tryAndCancel: "Vous pouvez <strong>essayer pendant {days} jours gratuitement</strong> et annuler à tout moment si vous n’êtes pas convaincu",
    noPremiumAccess: "Sans Tokatab Premium, vous avez accès uniquement à",
    access1: "Notre répertoire de 100+ morceaux, à apprendre en autonomie",
    access2: "2 challenges gratuits",
    access3: "500+ exercices et vidéos pour apprendre les compétences clés au piano",
    access4: "Les recommandations du prof virtuel Tokatab",
    tryPremium: "J’essaie gratuitement Tokatab Premium",
    noThanks: "Non merci",
    subscriptionLabel: "Abonnement {label}",
    trialDurationThen: "{days} jours d’essai, puis",
  },
  onboardingTrialSlide: {
    title: "Bénéficiez d'un accompagnement personnalisé 24/7",
    content1: "Grâce à notre formule d'abonnement, accédez à toutes les <span class='text-bold'>ressources d'apprentissage</span> de Tokatab et bénéficiez de <span class='text-bold'>l'accompagnement de votre professeur virtuel</span> à tout moment.",
    content2: "Nous vous offrons <span class='text-bold'>{days} jours d'essai gratuits, sans aucun engagement</span>, pour vous permettre de tester ce service.",
    seeOffers: "Voir les offres",
    startTrial: "Profiter de {days} jours offerts",
    error: "Une erreur est survenue, veuillez réessayer...",
  },
  onboardingTrialFreemiumSlide: {
    titleFreemium: 'Tokatab gratuit',
    titlePremium: 'Tokatab Premium',
    freemiumDay: 'Profitez de <strong>3 contenus offerts </strong> par jour (exercices, challenges ou parties de morceaux).',
    freemiumWeek: 'Progressez gratuitement grâce à <strong>5 contenus offerts </strong> par semaine (exercices, challenges ou parties de morceaux).',
    premium: 'Envie de progresser encore plus vite ? Passez à <strong>Tokatab Premium</strong> à tout moment pour travailler un nombre illimité de contenus.',
    info: 'Les contenus sont les mêmes pour tous. Seule la quantité {period} est limitée dans la version gratuite.',
    periodDay: 'quotidienne',
    periodWeek: 'hebdomadaire',
    tryForFree: 'Essayez Tokatab gratuitement',
    continue: 'Continuer',
  },
  onboardingTeacherSlide: {
    chooseTitle: "Choisissez l’apparence de votre coach Tokatab",
    chooseInfo: "Vous pourrez changer ce choix plus tard si vous le souhaitez.",
    continue: "Continuer",
    selectedTitle: "Enchanté{e}, {name} !",
    selectedTitleNoName: "Enchanté{e} !",
    selectedInfo: "Je serai votre guide : à chaque étape, je vous conseillerai en fonction de vos progrès et de vos objectifs.",
  },
  onboardingSingSlide: {
    title: 'Le piano-voix !',
    intro: "L’accompagnement piano-voix est une discipline courante au piano. Apprendre à vous accompagner au piano pour chanter en même temps vous intéresse-t-il ?",
    details: "Tout au long de votre parcours d'apprentissage, nous pourrons aborder les techniques du piano-voix et travailler sur des chansons populaires.<br>Afin de vous les proposer dans les tonalités les plus adaptées à votre voix, je vous propose de faire un test de votre tessiture !<br><br>(votre tessiture correspond à l'étendue des notes que votre voix peut chanter)",
    askTest: 'Souhaitez-vous faire le test maintenant ?',
    footer: "Si vous n'êtes pas en mesure de faire le test maintenant, vous pourrez y accéder plus tard dans votre profil.",
    interested: "ça m'intéresse",
    notInterested: 'Non merci',
    doTest: 'Je fais le test !',
  },
  onboardingSignupValidationSlideFreemium: {
    title: '🎉 Votre compte est créé !',
    welcome: 'Bienvenue dans Tokatab 👋',
    intro: 'Voici ce qui vous attend :',
    step1: 'Des centaines d’exercices, morceaux et challenges créés par des professeurs diplômés',
    step2: 'Un coach virtuel qui vous guide selon vos progrès et vos besoins',
    step3: 'De nouvelles compétences à débloquer à chaque étape',
    step4: 'Des progrès concrets, surtout si vous pratiquez régulièrement 😉',
    continue: 'Continuer',
  },
  onboardingSignupValidationSlideAb: {
    title: 'Rejoignez des milliers de musiciens débutants ou confirmés qui progressent au piano avec <strong>Tokatab</strong>',
    rating: 'Play Store',
    testimonial: '" Je suis agréablement surprise de ce programme qui me permet de reprendre le piano après une longue période sans jouer. Je prends un grand plaisir à suivre les leçons et apprendre les morceaux. Merci ! "',
    user: '<strong>Myriam</strong>, utilisatrice<br />Tokatab depuis 2023',
    continue: 'Continuer',
  },
  onboardingSignupValidationSlide: {
    title: 'Votre inscription est terminée !',
    intro: 'En tant que professeur virtuel je vais avoir le plaisir de vous accompagner dans votre apprentissage. Ensemble nous pourrons aborder :',
    exercises: '{count} exercices, challenges et vidéos',
    exercisesDesc: 'pour vous faire découvrir et travailler les principaux gestes du piano (jeu mélodique, jeu en accords, arpèges, motifs rythmiques, indépendances des mains, etc.)',
    pieces: '{count} morceaux complets',
    piecesDesc: 'arrangés par des musiciens, pour tous les niveaux, pour appliquer de façon ludique et musicale vos nouveaux acquis.',
    continue: 'Continuer',
  },
  onboardingSelectDisplayModeSlide: {
    askTitle: 'Savez-vous lire la musique ?',
    askSubtitle: 'Cela m’aidera à vous suggérer l’affichage musical le plus adapté.',
    selectTitle: 'Quel mode d’affichage souhaitez-vous pour commencer ?',
    selectSubtitle: 'Sur Tokatab, le solfège est proposé… mais jamais imposé.',
    answerNone: 'Non',
    answerSol: 'Je sais un peu lire la clef de Sol',
    answerSolFa: 'Je sais un peu lire la clef de Sol et la clef de Fa',
    answerRead: 'Oui, je sais bien lire la musique',
    partition: 'Partition',
    pianoRoll: 'Piano roll',
    recommended: 'Conseillé pour vous',
    changeAnytime: 'Vous pourrez modifier votre choix à tout moment',
  },
  onboardingPlugKeyboardSlide: {
    titlePlug: 'Branchez votre clavier à votre appareil !',
    titleDetected: 'Nous avons détecté votre clavier !',
    titleSuccess: 'Super !',
    plugInstruction: 'Grâce à un câble compatible MIDI, branchez directement Tokatab à votre appareil. Tokatab pourra vous faire des retours de façon optimale et continue.',
    playC: 'Jouez et tenez enfoncé la touche Do au centre du piano, elle est toujours indiquée par le petit rond vert à sa gauche.',
    keyFeedback: 'Les touches deviennent vertes lorsque vous les jouez correctement et rouges lorsque vous vous trompez.',
    tooLow: 'Jouez un peu plus haut sur le clavier !',
    tooHigh: 'Jouez un peu plus bas sur le clavier !',
    helpMidi: 'Comment brancher un clavier MIDI, avec quel câble ?',
    helpPlug: "J'ai besoin d'aide avec le branchement de mon clavier.",
    success: 'Je vais pouvoir vous accompagner de façon optimale tout au long de votre parcours d’apprentissage en tenant compte de votre jeu.',
    noCable: "Je n'ai pas de cable adapté",
    next: 'Suivant',
  },
  onboardingNotificationSlide: {
    title: 'Votre planning de séances',
    sessionsInfo: "Des sessions courtes mais régulières, c'est l'idéal pour progresser. Planifiez vos créneaux, je vous enverrai un rappel au bon moment.",
    whichDays: 'Quels jours avez-vous 15 minutes ou plus devant vous ?',
    notificationsInfo: "Afin que je puisse vous envoyer des rappels de nos éventuelles sessions j'ai besoin que vous activiez les notifications pour Tokatab.<br>Vous pourrez les désactiver facilement et à tout moment si cela ne vous convient pas.",
    mustSelectDay: 'Vous devez choisir au moins un jour pour votre séance de piano.',
    mustUseMobile: "Vous devez utiliser l'application mobile pour activer les notifications.",
    noActivate: 'Ne pas les activer',
    activate: "J'active les notifications !",
    noPlanning: 'Ne pas fixer de créneau',
    continue: 'Continuer'
  },
  notificationsPermission: {
    title: 'Un rappel au bon moment, ça aide',
    content1: 'Pour bien commencer, je vous conseille d’activer les notifications.',
    content2: 'Je pourrai ainsi vous rappeler au bon moment de réviser les notions clés et vous aider à progresser plus vite.',
    later: 'Plus tard',
    enable: 'Activer les notifications',
  },
  onboardingNewsSlide: {
    title: 'Nous avons des nouveautés pour vous !',
    subtitle: 'Nous avons besoin de quelque informations pour les activer, ne vous inquiétez pas, ce sera rapide !',
    continue: 'Continuer'
  },
  onboardingNameSlide: {
    title: 'Faisons connaissance !',
    question: 'Comment voulez-vous que je vous appelle ?',
    label: 'Votre prénom ou pseudo',
    required: 'Saisissez votre prénom',
    tooLong: 'Prénom trop long',
    continue: 'Continuer'
  },
  onboardingMandatoryPlayerSlide: {
    title: 'Adaptons votre expérience !',
    subtitle: 'Afin de vous permettre d\'utiliser ces fonctionnalitées, nous avons besoin de quelques informations supplémentaires.<br>Vous aurez besoin de votre piano pour les étapes suivantes.',
    noPiano: "Je n'ai pas mon piano",
    letsGo: "C'est parti !"
  },
  onboardingLevelSlideResult: {
    buildingTitle: 'Création de votre parcours…',
    estimateTitle: 'Votre parcours personnalisé est prêt !',
    pathDescription1: 'Vous allez commencer de zéro et construire des bases techniques solides, pas à pas.',
    pathDescription3: "Vous allez consolider vos bases et développer vos premiers réflexes avec les deux mains",
    pathDescription5: "Vous allez consolider l’aisance de votre jeu en pratiquant les gestes les plus courants des pianistes amateurs et aborder des techniques plus avancées.",
    testInfo: 'Vous pourrez modifier ce parcours à tout moment s’il ne vous convient pas.',
    continue: 'Continuer'
  },
  onboardingLevelSlide: {
    title: 'Quel est votre niveau au piano ?',
    pathTitle: 'Choisissez l\'option qui décrit le mieux le parcours qui vous correspond en piano',
    neverPlayed: "Je n’ai jamais joué",
    oneHand: 'Je peux jouer quelques notes avec une main',
    oneHandBack: "J'ai su jouer des extraits à une main",
    simpleTwoHands: 'Je peux jouer des morceaux très simples avec les deux mains',
    simpleTwoHandsBack: "J'ai su jouer des morceaux simples à deux mains",
    longTwoHands: 'Je peux jouer des morceaux simples et assez longs avec les deux mains',
    longTwoHandsBack: "J'ai su jouer des morceaux assez longs à deux mains",
    complex: 'Je peux jouer des morceaux longs et techniques',
    complexBack: "J'ai su jouer des morceaux longs et complexes techniquement"
  },
  onboardingKeyboardSlideResultNotCompatible: {
    title: "Votre plateforme n'est pas compatible",
    chromeOnly: "Malheureusement, seul le navigateur Chrome supporte aujourd'hui la reconnaissance midi. Nous vous invitons à le télécharger et l'utiliser pour Tokatab si vous souhaitez brancher votre clavier compatible.",
    openChrome: "Je reprends avec Chrome",
    alreadyChrome: "Si vous avez déjà Google Chrome, ouvrez simplement le navigateur et retournez sur app.tokatab.com.",
    installChrome: "Sinon, vous pouvez installer Chrome en cliquant sur le logo ci-dessous :",
    continueWithoutMidi: "Je continue sans midi"
  },
  onboardingKeyboardSlideResult: {
    noPianoYet: 'Pas encore de piano ?',
    noPianoNoWorries: 'Pas de souci !',
    exploreApp: 'Vous pouvez déjà explorer l\'application pour découvrir le fonctionnement. Et si vous envisagez de vous en procurer un pour en profiter pleinement, nous avons préparé un guide pour vous aider 👇',
    buyingGuide: '📖 Guide d\'achat',
    buyingGuideLabel: 'Guide d\'achat piano',
    seeBlog: 'Voir sur le blog',
    continue: 'Continuer'
  },
  onboardingKeyboardSlide: {
    selectType: 'Tokatab est capable de détecter les notes que vous jouez. Quel type de piano utilisez-vous ?',
    digital: 'Un piano numérique / un synthétiseur',
    acoustic: 'Un piano acoustique',
    dontKnow: 'Je ne sais pas',
    changeLater: 'Vous pourrez toujours changer ce choix plus tard !',
    selectMethod: 'Vous avez deux solutions pour permettre à Tokatab de capter votre jeu, choisissez l’une des deux',
    withMic: 'Avec le microphone',
    micDesc1: 'Analyse le son de votre piano et reconnait les notes jouées',
    micDesc2: 'Confidentialité assurée : les enregistrements restent sur votre appareil et sont effacés systématiquement',
    withMidi: 'Avec un câble',
    midiDesc1: 'Encore plus précis que le captage via le micro',
    midiDesc2: 'Nécessite un câble adapté (nous vous guiderons pour trouver le bon si besoin)',
    notCompatible: "Mince, il semble que votre appareil n'est pas compatible avec cette fonctionnalité",
    notAllowed: "Ah, vous avez refusé l'accès au microphone !",
    digitalUnplugged: 'Tokatab avec un piano numérique non branché !',
    acousticMic: 'Tokatab avec un piano acoustique',
    micNeeded1: 'La détection des notes que vous jouez est possible grâce au micro de votre appareil. Pour que vous puissiez profiter de cette fonctionnalité, nous avons besoin d’accéder à votre micro.',    micNeeded1Full: 'La détection des notes que vous jouez est possible grâce au micro de votre appareil. Pour que vous puissiez profiter de cette fonctionnalité, nous avons besoin d\'accéder à votre micro.',    micNeeded2: 'Nous respectons votre vie privée : les enregistrements seront analysés sur votre appareil et ne seront jamais sauvegardés ! Le micro n\'est utilisé que lorsque le mode écoute est activé, jamais par défaut.',
    privacyRespect: 'Nous respectons votre vie privée : les enregistrements seront analysés sur votre appareil et ne seront jamais sauvegardés ! Le micro n\'est utilisé que lorsque le mode écoute est activé, jamais par défaut.',
    listenMode: "Tout au long de votre parcours, en cliquant sur ce bouton <q-icon color='white' name='mdi-ear-hearing' size='15px' class='disable-button q-pa-xs' /> vous activerez le <strong>mode écoute</strong> qui me permettra d'entendre le son de votre piano pour vous faire des retours.",
    listenModeValidated: 'Tout au long de votre parcours, en cliquant sur ce bouton vous activerez le <strong>mode écoute</strong> qui me permettra d\'entendre le son de votre piano pour vous faire des retours.',
    notAllowedInfo1: "Si vous changez d'avis, il vous suffira de cliquer à nouveau sur ce bouton pour activer le <strong>mode écoute</strong> et permettre au professeur virtuel de savoir si vous jouez les bonnes notes ou non.",
    notAllowedInfo2: 'Nous vous réindiquerons comment autoriser votre micro.',
    fallback1: "Le prof virtuel de Tokatab pourra néanmoins personnaliser votre parcours d'apprentissage.",
    fallback2: "Vous pouvez essayer de refaire le test de performance de votre appareil ou passer à la suite.",
    allowMic: "Autoriser l'accès au micro",
    retry: 'Réessayer',
    continue: 'Continuer',
    powerQuestion: "Est-ce que votre piano a besoin d'une alimentation électrique pour fonctionner ?",
    yes: 'Oui',
    no: 'Non',
    willHelp: 'Je vais tout de même vous accompagner !',
    willAdapt: "Tout au long de votre parcours d'apprentissage, j'adapterai mes recommandations en fonction de vos réponses à mes questions.",
    noPianoTitle: 'Tokatab sans piano',
    noPianoAdvice: "Sans piano, difficile de progresser avec Tokatab. N'hésitez pas à lire nos articles si vous cherchez des conseils pour acquérir un piano.",
    guide1: "Lire le guide d'achat d'un piano entre 50 et 200€ !",
    guide2: "Lire le guide d'achat d'un piano pour 300€ !",
    needPianoTitle: 'Sur quel instrument allez-vous jouer ?',
    digitalPiano: 'Piano numérique / Synthétiseur',
    acousticPiano: 'Piano acoustique',
    midiKeyboard: 'Clavier MIDI',
    noPiano: 'Je n\'ai pas encore de piano',
    keyboardInfo: {
      digitalTitle: "Piano numérique / Synthétiseur",
      digitalContent1: "Il doit être branché à une prise électrique pour fonctionner.",
      digitalContent2: "Il produit du son via ses haut-parleurs intégrés.",
      digitalContent3: "Il possède une prise USB ou une prise MIDI.",
      acousticTitle: "Piano acoustique",
      acousticContent1: "Soit un piano droit, soit un piano à queue.",
      acousticContent2: "Il possède des cordes qui génèrent le son et n'a pas besoin d'être branché à une prise électrique.",
      midiTitle: "Clavier MIDI",
      midiContent1: "Comme une souris d'ordinateur, c'est un contrôleur.",
      midiContent2: "Il ne produit aucun son par lui-même.",
      midiContent3: "Il doit être relié à un logiciel de musique pour contrôler les sons.",
    },
    buyingGuide300: "Lire le guide d'achat d'un piano pour 300€ !",
    buyingGuideShort300: "Guide d'achat piano 300€ !",
    buyingGuide50to200: "Lire le guide d'achat d'un piano entre 50 et 200€ !",
    buyingGuideShort50to200: "Guide d'achat piano 50-200€ !",
    noPianoMessage: "Sans piano, difficile de progresser avec Tokatab. N'hésitez pas à lire nos articles si vous cherchez des conseils pour acquérir un piano.",
    adaptRecommendations: "Tout au long de votre parcours d'apprentissage, j'adapterai mes recommandations en fonction de vos réponses à mes questions.",
  },
  onboardingInitialOnboardingEndSlide: {
    title: "Découvrez l'application !",
    missions: "Sur la page d'accueil, des missions vous attendent pour découvrir l'application — et elles commencent tout de suite.",
    progressPill: 'Parcours découverte — {done}/{total} déjà complétées ✓',
    discover: 'Je découvre Tokatab',
    downloadTitle: "Téléchargez l'application pour utiliser Tokatab !",
    downloadCta: "Cliquez sur le bouton ci-dessous pour installer l'application",
  },
  onboardingInitialEvaluationSlide: {
    title: 'Il est temps de jouer du piano !',
    intro: 'Pour vous familiariser avec Tokatab et sa notation, et pour connaître vos compétences en piano, nous vous proposons un test de niveau !',
    challenges: "Il s'agit d'une succession de défis de plus en plus difficiles qui nous permettrons de valider vos acquis !",
    program: 'Nous pourrons ensuite vous préparer un programme sur mesure pour vous faire progresser.',
    start: "C'est Parti !"
  },
  onboardingHasPianoSlide: {
    question: 'Avez-vous votre piano sous la main ?',
    subtitle: 'Si oui, je vous propose un mini-tuto de quelques notes pour jouer tout de suite.',
    yes: 'Oui',
    no: 'Non'
  },
  onboardingHandSizeSlide: {
    titlePresentation: 'Calcul de la taille de vos mains',
    titleLeft: 'Calcul de la taille de votre main gauche',
    titleRight: 'Calcul de la taille de votre main droite',
    titleEnding: 'Merci !',
    btnContinue: 'Continuer',
    btnRetry: 'Refaire le test',
    btnConfirm: 'Confirmer',
    slideTextPresentation: 'Nous allons mesurer la taille de vos mains afin d’adapter mes conseils à leur morphologie.<br> Cela m’évitera ainsi de vous faire travailler et jouer des choses inadaptées.',
    slideTextEnding: "J'ai bien enregistré la taille de vos mains.<br>Je tiendrai compte de ce paramètre pour la suite de votre parcours d'appprentissage.<br>Si besoin, vous pouvez refaire ce test à tout moment en vous rendant dans votre profil.",
    errorPlacementWrong: 'Veuillez placer votre pouce sur le Do central et ne pas croiser les doigts.',
    errorTooLarge: "Il n'est pas possible d'avoir une main aussi grande !",
    warningTooSmall: 'Êtes vous sûr de bien ouvrir votre main au maximum ?',
    warningSmall: 'Êtes vous sûr de ne pas pouvoir ouvrir un peu plus ?',
    warningLarge: 'Quelle main ! Utilisez vous bien la même main pour jouer les 2 touches ?',
    stepRight: 'Enfoncez la touche du Do central avec votre pouce de la main droite.<br>Tout en maintenant cette touche enfoncée, jouez la note la plus éloignée possible avec votre petit doigt, puis indiquez-moi cette note sur le clavier ci-dessous.<br><strong>Ne forcez pas trop, cela doit rester “confortable.”</strong>',
    stepLeft: 'De la même façon, enfoncez la touche du Do central avec votre pouce de la main gauche.<br>Tout en maintenant cette touche enfoncée, jouez la note la plus éloignée possible avec votre petit doigt, puis indiquez-moi cette note sur le clavier ci-dessous.<br><strong>Ne forcez pas trop, cela doit rester “confortable.”</strong>',
    midiRight: 'Enfoncez la touche du Do central avec votre pouce de la main droite.',
    midiLeft: 'De la même façon, enfoncez la touche du Do central avec votre pouce de la main gauche.',
    midiFingers: 'Tout en maintenant cette touche enfoncée, jouez la note la plus éloignée possible avec votre petit doigt.',
    midiHold: 'Tenez les deux touches enfoncées pendant 5 secondes pour valider le test !',
    results: 'Veuillez confirmer la taille de votre main ou refaire le test. (attention à ne pas trop tirer la main, le but est de déterminer le plus grand écart que vous puissiez jouer, sans que ce soit trop inconfortable)'
  },
  onboardingGoalSlide: {
    title: 'Quels sont vos objectifs au piano ?',
    subtitle: 'Plusieurs choix possibles — cela m’aidera à vous proposer un parcours adapté.',
    continue: 'Continuer'
  },
  onboardingGenericEndSlide: {
    title: 'Merci pour ces précisions !',
    subtitle: "Maintenant c'est à vous de jouer !",
    finish: 'Terminer'
  },
  onboardingChecklistRecap: {
    title: 'Découverte de Tokatab',
    description: 'Complétez ces missions pour découvrir et enrichir votre expérience avec Tokatab.',
    daysUnlocked: 'Vous avez débloqué <span class="text-primary text-bold">{count} jours</span> d\'essai gratuit supplémentaires !',
    daysNotUnlocked: 'Vous n\'avez pas encore débloqué de jours d\'essai gratuit supplémentaires.',
    daysLeft: 'Il vous en reste <span class="text-primary text-bold">{count} à débloquer</span>.',
    allDaysUnlocked: 'Vous avez débloqué tous les jours d\'essai gratuit ! Compléter cette liste pour découvrir toutes les fonctionnalités de Tokatab !',
    missions: 'missions',
    seeRemaining: 'Voir les missions restantes',
    hide: 'Ne plus afficher',
    hideNotify: 'Cette liste ne s\'affichera plus sur la page d\'accueil, vous pourrez la retrouver dans votre profil.',
    hideNotifyOk: 'Vous pourrez retrouver cette liste dans votre profil.'
  },
  onboardingChecklistPage: {
    title: 'Découverte de Tokatab',
    back: 'Retour',
    trialDay: 'jour',
    toUnlock: 'de période d\'essai à débloquer',
  },
  onboardingChecklistController: {
    basic_info: '👀 Décrivez moi votre niveau en piano',
    objectives: '🎯 Définissez vos objectifs',
    equipment: '🎹 Quel piano utilisez-vous ?',
    hand_size: '🤲 Calculons la taille de vos mains',
    training_program: '🗓 Établissons votre planning',
    email_validation: '💌 Validez votre email',
    singing: '🎤  Déterminons votre tessiture vocale',
    initial_evaluation: '🥇 Passons votre test de niveau en piano',
    tokatab_exercises: '📘 Validez un premier exercice',
    import_my_piece: '📥 Importez un morceau depuis votre bibliothèque musicale',
    first_module: '🎓 Terminez votre premier module',
    plug_piano: '🔌 Branchez votre piano !',
    notify_first_song: "Voici la liste des morceaux, choisissez en un et terminez l'apprentissage d'une partie en utilisant le mode guidé pour compléter cet objectif !",
    notify_tokatab_exercises: 'Voici la liste des modules, choisissez en un et complétez au moins un exercice pour terminer cet objectif.',
    notify_first_module: 'Voici la liste des modules, choisissez en un terminez le pour compléter cet objectif.',
    notify_checklist_complete: 'Bravo vous avez complété la checklist, vous êtes maintenant prêt pour profiter de toutes les fonctionnalitées de Tokatab !',
    notify_mission_complete: 'Bravo vous avez terminé une des missions de la découverte de Tokatab !',
    notify_mission_complete_days: 'Vous avez gagné {count} jour(s) d\'essai gratuit supplémentaires !',
    notify_import_my_piece: "Importez un morceau depuis votre bibliothèque musicale pour compléter cet objectif !"
  },
  onboardingIntroJsService: {
    nextMobile: '>',
    nextDesktop: 'Suivant',
    prevMobile: '<',
    prevDesktop: 'Précédent',
    doneMobile: 'x',
    doneDesktop: 'Terminer',
    hintButton: "C'est compris"
  },

  onboardingSongPageData: {
    hints: {
      listen: 'Cliquez ici pour écouter le morceau.',
      lyrics: "Dans cet onglet, vous trouverez les paroles complètes du morceau. N'hésitez pas à les réviser pour ensuite pouvoir vous accompagner au piano."
    }
  },

  onboardingPlayerData: {
    PlayerTour: {
      listenButton: {
        title: 'Mode écoute',
        intro: 'Cliquez sur ce bouton pour activer le mode écoute et permettre au professeur Tokatab de vous faire des retours en fonction des notes que vous jouez.'
      }
    },
    PlayerFreeModeTour: {
      loop: {
        title: 'Travailler à votre rythme en autonomie',
        intro: 'En cliquant ici vous pourrez activer une boucle de la partie sur laquelle vous vous trouvez.'
      },
      speed: {
        title: 'Travailler à votre rythme en autonomie',
        intro: 'Ici vous gérez la vitesse de lecture, bouton très important pour travailler le morceau en baissant la vitesse !'
      },
      help: {
        title: 'Travailler à votre rythme en autonomie',
        intro: "Enfin, ce bouton est très important ! Il vous permet d'activer une assistance d'apprentissage étape par étape du morceau."
      }
    },
    PlayerClassTour: {
      step1: {
        title: 'Mode cours',
        intro: 'Ici Tokatab vous guide étape par étape pour apprendre le morceau !'
      },
      step2: {
        title: 'Mode cours',
        intro: "Chaque lettre colorée correspond à une section. C'est un passage musical plus court et facilement mémorisable !"
      },
      step3: {
        title: 'Mode cours',
        intro: 'Jouer une partie revient à enchaîner toutes ses sections.'
      },
      step4: {
        title: 'Mode cours',
        intro: "Souvent des parties différentes ont des sections en commun qu'il suffit d'apprendre une fois."
      }
    },
    PlayerScoreEvolutionTour: {
      step1: {
        title: 'Les scores',
        intro: 'Le score monte de 0 à 100 et indique à quel point ce morceau ou ce challenge sera facile à apprendre pour vous.'
      },
      step2: {
        title: '100% personnalisé',
        intro: 'Ce score est 100% personnalisé, et calculé en fonction des techniques que vous avez déjà pratiquées sur Tokatab. Plus vous jouerez de challenges, morceaux et exercices, plus le score augmentera !'
      }
    },
    ShowParameterTour_tempo: {
      step1: {
        title: 'Changer le tempo',
        intro: 'Ici vous pouvez gérez la vitesse de lecture !'
      }
    },
    ShowParameterTour_sound: {
      step1: {
        title: 'Gérer les volumes',
        intro: 'Ici vous pouvez augmenter ou baisser les volumes !'
      }
    },
    ShowParameterTour_MobileDisplayMenu: {
      step1: {
        title: "Gérer l'affichage",
        intro: "Ici vous pouvez changer différents paramètres d'affichage !"
      }
    },
    ShowParameterTour_displayFingerOrNotes: {
      step1: {
        title: 'Affichage des notes ou des doigtés',
        intro: "C'est ici que vous pouvez choisir d'afficher les doigtés ou les notes !"
      }
    },
    ShowParameterTour_listenModeButton: {
      step1: {
        title: 'Mode écoute',
        intro: 'Cliquez sur ce bouton pour activer le mode écoute et permettre au professeur Tokatab de vous faire des retours en fonction des notes que vous jouez.'
      }
    },
    ShowParameterTour_sheetMusicMode: {
      step1: {
        title: 'Mode piano roll ou partition',
        intro: 'En cliquant sur ce bouton vous pouvez choisir entre le mode piano roll ou le monde partition !'
      }
    }
  },

  onboardingHomeData: {
    hints: {
      challenge: "N'oubliez pas que si vous avez peu de temps devant vous, valider des challenges est une solution rapide pour progresser sur des notions clés du piano tout en vous amusant !",
      profil: "Depuis votre page Profil, vous pourrez gérer votre abonnement et la configuration de Tokatab.",
      filterVersion: "Les versions inspirées contiennent les éléments principaux de la chanson qui les rendent très reconnaissables. Les versions originales sont presque identiques aux enregistrements d'origine.",
      sortBy: "Trier les résultats \"par maîtrise\" permet d'afficher en premier les morceaux que vous aurez le moins de difficulté à apprendre, car vous en connaissez déjà certaines techniques."
    }
  },

  onboardingIntroPlayerModal: {
    slides: {
      tuto_welcome: { content: 'Je vous propose de découvrir comment jouer avec Tokatab grâce à un challenge tutoriel.<div class="q-mt-sm">Les challenges sont de petits extraits pratiques pour réviser et appliquer vos compétences au piano.</div>' },
      tuto_validation: { content: 'Comme tous les contenus proposés dans l’application, il faudra réussir à jouer ce challenge à tempo 100 % pour le valider.' },
      piano_1: { content: 'Tokatab utilise un mode de représentation sans solfège.' },
      piano_2: { content: 'Vous allez voir défiler sur votre écran les touches à jouer sur votre piano.' },
      piano_3: { content: 'Les touches <span class="text-orange">oranges</span> sont celles à jouer avec les doigts de votre <span class="text-orange">main droite</span>.' },
      piano_4: { content: 'Les touches <span class="text-primary">bleues</span> sont celles à jouer avec les doigts de votre <span class="text-primary">main gauche</span>.' },
      piano_5: { content: "Lorsqu'une touche s'allume sur le clavier virtuel de l'application, il faut la jouer en même temps sur votre piano et la tenir enfoncée tant qu'elle est allumée." },
      piano_7: { content: "Les numéros sur les touches vous indiquent quel doigt utiliser pour les jouer. Il faut bien les respecter !<br>(Le 1 pour le pouce, le 2 pour l'index, etc.)<br><img src='{img}' alt='doigts piano' style='width: 70%'>" },
      piano_8: { content: "Pour jouer le petit extrait qui va suivre, vous allez utiliser uniquement la main droite avec les doigts 1 (pouce), 2 (index) et 3 (majeur)." },
      partition_1: { title: 'Présentation du mode partition', content: 'Vous allez voir la partition défiler de droite à gauche.' },
      partition_2: { content: 'Les touches à jouer vous sont montrées sur le clavier virtuel sous la partition.' },
      partition_3: { content: 'Au moment où les notes passent dans cette zone grise, elles s’allument et il faut les jouer sur votre piano.' },
      partition_4: { content: "Les notes qui s'allument en <span class=\"text-orange\">orange</span> sont à jouer par la <span class=\"text-orange\">main droite</span>." },
      partition_5: { content: "Les notes allumées en <span class=\"text-primary\">bleu</span> sont à jouer par la <span class=\"text-primary\">main gauche</span>." },
      partition_6: { content: "Tant que les notes sont allumées, vous devez garder les touches correspondantes enfoncées sur votre piano." },
      partition_7: { content: "Les numéros sur les touches vous indiquent quel doigt utiliser pour les jouer. Il faut bien les respecter !<br>(Le 1 pour le pouce, le 2 pour l'index, etc.)<br><img src='{img}' alt='doigts piano' style='width: 70%'>" },
      play_button: { content: "Cliquez sur ce bouton pour lancer le morceau et le jouer en même temps sur votre piano. \n Un décompte vous laissera le temps de placer votre main.", imageWidth: '140px' },
      capture_audio_button: { content: "En cliquant sur ce bouton vous activerez le mode écoute qui permet au professeur virtuel de détecter votre jeu pour vous faire des retours. Vous pouvez faire apparaître ce bouton en cliquant sur l'icône du prof." }
    }
  },

  onboardingAskKeyboardAvailability: {
    title: 'Adaptons votre expérience !',
    subtitle: "Afin de vous permettre d'utiliser au mieux tokatab, nous avons besoin de vous faire passer quelque tests.<br> vous aurez besoin de votre piano pour les étapes suivantes.",
    skip: "Je n'ai pas mon piano",
    next: "C'est parti !"
  },

  onboardingChallengeSlide: {
    title: 'Il est temps de jouer du piano !',
    intro: 'Pour vous familiariser avec Tokatab et sa notation, nous vous proposons un petit challenge.',
    description: "Il s'agit d'un court extrait issu d'un morceau et que vous pourrez maîtriser et valider rapidement !",
    start: "C'est Parti !"
  },

  onboardingDaysNotificationSelector: {
    available: 'En général, vous êtes plutôt disponible le : :',
    morning: 'Matin',
    afternoon: 'Après-midi',
    evening: 'Soir'
  },

  onboardingEmailPasswordSlide: {
    passwordError: 'Min 8 caractères avec majuscules, minuscules et chiffres',
    passwordConfirmError: 'Vous avez entré 2 mots de passes différents',
    emailFormatError: "Format d'email invalide",
    almost: 'On y est presque !',
    choosePassword: 'Enfin, choisissez votre mot de passe',
    accountExists: "Oups, il semble qu'un compte existe déjà avec cet email !",
    twoSteps: 'Créez votre compte pour sauvegarder votre parcours personnalisé.',
    enterPassword: 'Entrez votre mot de passe pour vous connecter',
    email: 'Votre email *',
    password: 'Votre mot de passe *',
    passwordHint: 'Min 8 caractères avec majuscules, minuscules et chiffres',
    passwordConfirm: 'Confirmation du mot de passe *',
    passwordForgot: 'Mot de passe oublié ?',
    continue: 'Continuer',
    or: 'OU',
    createAccount: 'Créer mon compte',
    login: 'Se connecter',
    legalNotice: 'En cliquant sur « Créer mon compte », vous acceptez',
    legalNoticeLink: 'les Conditions générales d\'utilisation de Tokatab',
    invalidEmail: "Format d'email invalide",
    newsletterConsent: "J'accepte de recevoir les actualités de Tokatab (promis, pas de spam inutile !)"
  },

  onboardingCatalogPage: {
    hints: {
      listen: "Cliquez ici pour importer votre propre morceau au format MusicXML",
    }
  }
}
